export const eventBus = new Vue();
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCookies from 'vue-cookies';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import Notifications from 'vue-notification';
import 'vue-loading-overlay/dist/vue-loading.css';

import App from './App.vue';
import router from './routing';
import store from './store';
import filters from '@/shared/filters';
import directives from '@/shared/directives';
import validatesExtend from '@/shared/validates-extension';
import * as firebase from 'firebase';
// import './registerServiceWorker';


import '@/styles/app.style.scss';

// try {
//   const firebaseConfig = {
//     apiKey: 'AIzaSyDkMElEWZmvaPVQmhx1ZpBrMaz0ozRWFrw',
//     authDomain: 'viettaobao-oee.firebaseapp.com',
//     projectId: 'viettaobao-oee',
//     storageBucket: 'viettaobao-oee.appspot.com',
//     messagingSenderId: '416168122677',
//     appId: '1:416168122677:web:01b8433b52164f9a10147c',
//     measurementId: 'G-KMS42MMX9Q'
//   };
//   // Initialize Firebase
//   firebase.initializeApp(firebaseConfig);
//   firebase.analytics();

//   const messaging = firebase.messaging();
  
//   messaging.usePublicVapidKey('BOgNf9bFELoQEYzUCJb-l6kH6VnQGO8kS0LfjVBCnFYPczmT-ghhn5R64dB_d9gXNqKHhXHvoipHwshTITHqoJg'); // 1. Generate a new key pair
//   // Request Permission of Notifications
//   messaging.requestPermission().then(() => {
//     // console.log('Notification permission granted.');
//     // Get Token
//     messaging.getToken().then((token) => {
//       window.localStorage.setItem('FCM_Token', JSON.stringify(token));
//     })
//   }).catch();
//   messaging.onMessage((payload) => {
//     // console.log('onMessage: ', payload);
//   }); 
//   // const remoteConfig = firebase.remoteConfig();
//   // remoteConfig.settings.minimumFetchIntervalMillis = APP_CONFIG.firebaseTimeFetch;
//   // remoteConfig.defaultConfig = ({
//   //   'shipping_method': `[{ "value": 1, "name": "Viettel", "max_weight": 1000 }, { "value": 2, "name": "GHTK", "max_weight": 20 }]`,
//   // });
//   // remoteConfig.fetchAndActivate()
//   // .then(() => {
//   //   const shippingMethods = remoteConfig.getValue('shipping_method');
//   //   (window['getApp'] as any).$emit('SET_CONFIG_SHIPPING_METHOD', JSON.parse(shippingMethods.asString()));
//   // })
//   // .catch((err) => {
//   //   // console.error(err);
//   // });
// } catch (error) {
//   // expected output: ReferenceError: nonExistentFunction is not defined
//   // Note - error messages will vary depending on browser
// }

Vue.config.productionTip = false;

// Validate
for (const rule in rules) {
  extend(rule, {
    ...rules[rule],
  });
}

for (const rule in validatesExtend) {
  extend(rule, {
    ...validatesExtend[rule],
  });
}

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
// End Validate

// Filter
for (const filter in filters) {
  Vue.filter(filter, filters[filter]);
}
// End Filter

// Init Directive
for (const directive in directives) {
  Vue.directive(directive, directives[directive]);
}
// End Directive


// Notify
Vue.use(Notifications);
// End Notify
Vue.use(VueCookies);

Vue.use(VueRouter);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
